import { render, staticRenderFns } from "./AltaPrioridadeBadge.vue?vue&type=template&id=36189f82&scoped=true"
import script from "./AltaPrioridadeBadge.vue?vue&type=script&lang=ts"
export * from "./AltaPrioridadeBadge.vue?vue&type=script&lang=ts"
import style0 from "./AltaPrioridadeBadge.vue?vue&type=style&index=0&id=36189f82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36189f82",
  null
  
)

export default component.exports